import * as React from 'react';
import { GitHubSourceMetadata, SourceType } from '@journeyapps-platform/types-source-service';
import { styled } from '../../../../theme';
import { System } from '../../../../System';
import { OrganizationModel } from '@journeyapps-platform/lib-journey-core';
import { GithubOrganizationsDropdownWidget } from './GithubOrganizationsDropdownWidget';
import { GithubReposDropdownWidget } from './GithubReposDropdownWidget';
import { IntegrationKind } from '@journeyapps-platform/types-cerberus';

export type GitHubPayload = {
  create_repo?: boolean;
  source?: GitHubSourceMetadata;
};

export interface GithubSourceControlSubStepWidgetProps {
  name: string;
  payload: GitHubPayload;
  payloadChanged: (payload: Partial<GitHubPayload>) => any;
  system: System;
  org: OrganizationModel;
  createIntegration: () => any;
}

export class GithubSourceControlSubStepWidget extends React.Component<GithubSourceControlSubStepWidgetProps> {
  setProperties = (params: { owner?: string; repo?: string; create?: boolean }) => {
    this.props.payloadChanged({
      create_repo: params.create ?? this.props.payload.create_repo,
      source: {
        type: SourceType.GitHub,
        properties: {
          owner: (params.owner ?? this.props.payload.source?.properties.owner) || '',
          repo: (params.repo ?? this.props.payload.source?.properties.repo) || ''
        }
      }
    });
  };

  render() {
    return (
      <S.Content>
        <GithubOrganizationsDropdownWidget
          org={this.props.org}
          githubOrg={this.props.payload.source?.properties?.owner}
          githubOrgChanged={(orgName) => {
            this.setProperties({
              owner: orgName
            });
          }}
          createIntegration={this.props.createIntegration}
        />
        {this.props.payload.source?.properties?.owner ? (
          <GithubReposDropdownWidget
            groupingName="organization"
            appName={this.props.name}
            repo={this.props.payload.source?.properties?.repo}
            setProperties={this.setProperties}
            org={this.props.org}
            integration={
              this.props.org.integrations.items.find(
                (i) => i.getProperties<IntegrationKind.GitHub>().org === this.props.payload.source!.properties.owner
              )!
            }
          />
        ) : null}
      </S.Content>
    );
  }
}

namespace S {
  export const Content = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 416px;
  `;
}
